module.exports = __webpack_public_path__ + "img/capture-single.af5b8110.gif";